import React from 'react';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { loginButton } from '../../themes/styles';
import {
  googleSignIn,
  setUrlSignUpParamsInLocalStorage,
  GET_STARTED_DATA_KEY,
  logger,
} from '../../utils';
import { GetStartedData } from '../../Types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  googleSignUpButton: {
    ...loginButton,
    background: theme.palette.brand.blueDark,
    color: theme.palette.brand.white,
    marginBottom: theme.spacing(1),
    fontSize: ({ large }: { large: boolean }) => {
      return large ? theme.fontSizes.onboarding : 'default';
    },
    '&:hover': {
      background: theme.palette.brand.blueDark,
      opacity: 0.9,
    },
  },
}));

interface Props {
  large?: boolean;
  getStartedData?: GetStartedData;
}

export default function SignInGoogle({ large = false, getStartedData }: Props) {
  const classes = useStyles({ large });
  const snackbar = useSnackbarContext();

  async function handleClick() {
    try {
      setUrlSignUpParamsInLocalStorage();
      if (getStartedData) {
        localStorage.setItem(
          GET_STARTED_DATA_KEY,
          JSON.stringify(getStartedData),
        );
      }
    } catch (error) {
      logger.error({
        message: 'google_sign_in_save_params_locally',
        error,
      });
    }
    await googleSignIn({ snackbar });
  }

  return (
    <Button
      variant="contained"
      className={classes.googleSignUpButton}
      onClick={handleClick}
    >
      Continue with Google
    </Button>
  );
}
